import React from 'react';
import { components } from 'react-select';
import { kebabCase } from 'lodash';
import { SelectCheckboxOption } from './SelectCheckboxOption';
import { SelectClearTooltip } from './SelectClearTooltip';
import PropTypes from 'prop-types';
import { Chip } from '../../Chip/component';
import { DesignSystem } from '@everfi/design-system';

const {
  DropdownIndicator,
  IndicatorsContainer,
  IndicatorSeparator,
  MenuList,
  SelectContainer,
  SingleValue,
  ValueContainer,
} = components;

const SelectComponentWrapper = ({
  Component = <></>,
  componentName = '',
  componentProps = {},
  wrapperAttributes = {},
  wrapperStyle = {},
}) => {
  const { selectProps } = componentProps;
  const formattedName = selectProps?.name?.replace?.('[]', '') ?? '';
  const name = formattedName ? `-${formattedName}` : '';
  const dataObjectId = `Select${name}-${componentName}`;
  return (
    <div {...wrapperAttributes} data-object-id={dataObjectId} style={wrapperStyle}>
      <Component {...componentProps} />
    </div>
  );
};

export const DropdownIndicatorWrapper = props => (
  <SelectComponentWrapper Component={DropdownIndicator} componentName="dropdown-indicator" componentProps={props} />
);

export const IndicatorsContainerWrapper = props => (
  <SelectComponentWrapper Component={IndicatorsContainer} componentName="indicators" componentProps={props} />
);

export const IndicatorsSeparatorWrapper = props => (
  <SelectComponentWrapper Component={IndicatorSeparator} componentName="indicator-separator" componentProps={props} />
);

export const MenuListWrapper = props => (
  <SelectComponentWrapper Component={MenuList} componentName="menu-list" componentProps={props} />
);

export const MultiValueWrapper = (props = {}) => {
  const { children, removeProps } = props;
  const label = props?.data?.label || children;
  const wrapperAttributes = {
    'data-component-type': `${kebabCase(label)}-chip`,
  };
  const componentProps = {
    value: label,
    onRemove: removeProps?.onClick,
    sx: { mr: DesignSystem.Space.XS, mb: DesignSystem.Space.XS },
  };

  return (
    <SelectComponentWrapper
      Component={Chip}
      componentName="multi-value"
      componentProps={componentProps}
      wrapperAttributes={wrapperAttributes}
    />
  );
};

export const SelectContainerWrapper = props => (
  <SelectComponentWrapper Component={SelectContainer} componentName="container" componentProps={props} />
);

export const SingleValueWrapper = (props = {}) => {
  const wrapperAttributes = {
    'data-component-type': `${kebabCase(props?.data?.label)}-value`,
  };

  return (
    <SelectComponentWrapper
      Component={SingleValue}
      componentName="single-value"
      componentProps={props}
      wrapperAttributes={wrapperAttributes}
      wrapperStyle={{ gridArea: '1/1/2/3' }}
    />
  );
};

export const ValueContainerWrapper = props => (
  <SelectComponentWrapper Component={ValueContainer} componentName="value-container" componentProps={props} />
);

const propTypes = {
  Component: PropTypes.func,
  componentName: PropTypes.string,
  componentProps: PropTypes.object,
  data: PropTypes.shape({
    label: PropTypes.string,
  }),
  wrapperAttributes: PropTypes.object,
  wrapperStyle: PropTypes.object,
};

SelectComponentWrapper.propTypes = propTypes;
DropdownIndicatorWrapper.propTypes = propTypes;
IndicatorsContainerWrapper.propTypes = propTypes;
IndicatorsSeparatorWrapper.propTypes = propTypes;
MenuListWrapper.propTypes = propTypes;
MultiValueWrapper.propTypes = propTypes;
SelectContainerWrapper.propTypes = propTypes;
SingleValueWrapper.propTypes = propTypes;
ValueContainerWrapper.propTypes = propTypes;

export const selectComponents = {
  DropdownIndicator: DropdownIndicatorWrapper,
  IndicatorsContainer: IndicatorsContainerWrapper,
  IndicatorSeparator: IndicatorsSeparatorWrapper,
  MenuList: MenuListWrapper,
  MultiValue: MultiValueWrapper,
  Option: SelectCheckboxOption,
  SelectContainer: SelectContainerWrapper,
  SingleValue: SingleValueWrapper,
  ValueContainer: ValueContainerWrapper,
  ClearIndicator: SelectClearTooltip,
};
